import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Action} from '@ngrx/store';
import {Observable} from 'rxjs';
import {catchError, mergeMap, switchMap} from 'rxjs/operators';
import {createCallbackActions, emitErrorActions} from '../store.utils';
import {
  AlertsActionType,
  GetAlertsAction,
  GetAlertsSuccessAction,
  GetAlertsCountAction,
  GetAlertsCountSuccessAction,
  DismissAlertAction,
} from './alerts.action';
import {AlertsApiService} from '../../api/alerts-api.service';

@Injectable()
export class AlertsEffects {
  public get$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<GetAlertsAction>(AlertsActionType.GET),
      mergeMap(action => {
        const {onSuccess, onFailure} = action.payload;

        return this.alertsApiService.get().pipe(
          mergeMap(alerts => [new GetAlertsSuccessAction({alerts}), ...createCallbackActions(onSuccess)]),
          catchError(error => emitErrorActions(error, onFailure))
        );
      })
    )
  );

  public getCount$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<GetAlertsCountAction>(AlertsActionType.GET_COUNT),
      mergeMap(action => {
        const {onSuccess, onFailure} = action.payload;

        return this.alertsApiService.getCount().pipe(
          mergeMap(c => [new GetAlertsCountSuccessAction({count: c.count}), ...createCallbackActions(onSuccess)]),
          catchError(error => emitErrorActions(error, onFailure))
        );
      })
    )
  );

  public dismiss$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<DismissAlertAction>(AlertsActionType.DISMISS),
      mergeMap(action => {
        const {alertId, onSuccess, onFailure} = action.payload;

        return this.alertsApiService.dismiss(alertId).pipe(
          switchMap(() => this.alertsApiService.get()),
          mergeMap(alerts => [new GetAlertsSuccessAction({alerts}), ...createCallbackActions(onSuccess)]),
          catchError(error => emitErrorActions(error, onFailure))
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private alertsApiService: AlertsApiService
  ) {}
}
